import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';


if ($('.slide-show').length) {

	$('.slideshow-swiper').each(function() {
		var swiper = new Swiper(this, {
			effect: "fade",
			fadeEffect: {
				crossFade: true
			},
			loop: true,
			speed: 500,
			autoplay: {
				delay: 4000,
				disableOnInteraction: false,
			},
		});

		var $parent = $(this).parent();

		$parent.find('.next').on('click', function() {
			swiper.autoplay.stop();
			swiper.slideNext(500);
			setTimeout(() => swiper.autoplay.start(), 3000);
		});

		$parent.find('.prev').on('click', function() {
			swiper.autoplay.stop();
			swiper.slidePrev(500);
			setTimeout(() => swiper.autoplay.start(), 3000);
		});
	});

}
